import { Outlet } from "react-router-dom";
import { MobileFrame } from "../MobileFrame";
import { BottomNav } from "./BottomNav";

export const SalesLayout = () => {
  return (
    <MobileFrame>
      <div className="min-h-full flex flex-col bg-honda-bg pb-32">
        <div className="flex-1">
          <Outlet />
        </div>
        <BottomNav />
      </div>
    </MobileFrame>
  );
};
